import { render, staticRenderFns } from "./CombinationSale.vue?vue&type=template&id=460659d8&scoped=true"
import script from "./CombinationSale.vue?vue&type=script&lang=js"
export * from "./CombinationSale.vue?vue&type=script&lang=js"
import style0 from "./CombinationSale.vue?vue&type=style&index=0&id=460659d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460659d8",
  null
  
)

export default component.exports